/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `activity` - Aktivita * `touch` - Dotek
 */
export type ChildPortfolioRecordTypeEnum = 'activity' | 'touch';

export const ChildPortfolioRecordTypeEnum = {
    Activity: 'activity' as ChildPortfolioRecordTypeEnum,
    Touch: 'touch' as ChildPortfolioRecordTypeEnum
};